import React, { useEffect, useState } from 'react';
import { ControlPoint } from '@mui/icons-material';

import CustomSelect from '../../../../../inbound/components/CustomSelect';

import './_selectContractTemplate.scss';

import { useNavigate } from 'react-router-dom';

import CaretDown from '@/components/Icons/icons/CaretDown';

import CheckTick from '../../../../../../Icons/icons/CheckTick';

export const contractTemplateType = {
  PAY_PER_POST: 'PayPerPost',
  BASE_PLUS_BONUS: 'Base+Bonus',
  GIFTING_SEEDING: 'Gifting/Seeding',
  AMBASSADOR_AFFILIATE: 'Ambassador/Affiliate',
  UGC: 'UGC',
  WHITELISTING: 'Whitelisting',
};

const systemTemplates = [
  { label: 'Pay Per Post', value: contractTemplateType.PAY_PER_POST },
  { label: 'Base + Bonus', value: contractTemplateType.BASE_PLUS_BONUS },
  { label: 'Gifting/Seeding', value: contractTemplateType.GIFTING_SEEDING },
  { label: 'Ambassador/Affiliate', value: contractTemplateType.AMBASSADOR_AFFILIATE },
  { label: 'UGC', value: contractTemplateType.UGC },
  { label: 'Whitelisting', value: contractTemplateType.WHITELISTING },
];

export default function SelectContractTemplate({ value, onChange, customTemplates = [], onCreateTemplate }) {
  const [expandedSection, setExpandedSection] = useState('system');
  const navigate = useNavigate();

  // Effect to update expanded section when customTemplates changes
  useEffect(() => {
    if (Array.isArray(customTemplates) && customTemplates.length > 0) {
      setExpandedSection('custom');
    }
  }, [customTemplates]);

  const toggleSection = (section, e) => {
    e.stopPropagation();
    setExpandedSection(expandedSection === section ? null : section);
  };

  const getOptions = () => {
    const sections = [];

    if (Array.isArray(customTemplates) && customTemplates.length > 0) {
      // Add custom templates section first if they exist
      sections.push(
        {
          label: 'My Templates',
          value: 'custom_header',
          isSection: true,
          sectionKey: 'custom',
        },
        ...customTemplates,
        {
          label: 'System Templates',
          value: 'system_header',
          isSection: true,
          showSeparator: true,
          sectionKey: 'system',
        },
        ...systemTemplates
      );
    } else {
      // Add system templates first if no custom templates
      sections.push(
        {
          label: 'System Templates',
          value: 'system_header',
          isSection: true,
          sectionKey: 'system',
        },
        ...systemTemplates,
        {
          label: 'My Templates',
          value: 'custom_header',
          isSection: true,
          showSeparator: true,
          sectionKey: 'custom',
        }
      );
    }

    return sections;
  };

  const renderOption = ({ option, onChange, value, setShowDropdown }) => {
    const isSelected = option.value === value;

    if (option.isSection) {
      return (
        <>
          {option.showSeparator && <div className="section-separator" />}
          <div className="section-header" onClick={(e) => toggleSection(option.sectionKey, e)}>
            <span>{option.label}</span>
            <div className="section-header-right">
              {option.sectionKey === 'custom' && (!customTemplates || customTemplates.length === 0) && (
                <button
                  className="create-template-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate('/dashboard/settings?tab=general#contractTemplatesCard');
                  }}>
                  <ControlPoint /> Create Custom Template
                </button>
              )}
              {(!customTemplates || customTemplates.length > 0) && (
                <span
                  style={{
                    transform: expandedSection === option.sectionKey ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease-in-out',
                  }}>
                  <CaretDown />
                </span>
              )}
            </div>
          </div>
        </>
      );
    }

    if (
      (option.isCustomTemplate && expandedSection !== 'custom') ||
      (!option.isCustomTemplate && expandedSection !== 'system')
    ) {
      return null;
    }

    return (
      <div
        className={`contract-select-option ${isSelected ? 'contract-select-option-selected' : ''}`}
        onClick={() => {
          onChange(option.value);
          setShowDropdown(null);
        }}>
        <span>{option.label}</span>
        {isSelected && <CheckTick color="var(--purple-p-400)" />}
      </div>
    );
  };

  return (
    <CustomSelect
      dropDownMaxHeight="290px"
      label="Select Contract Template"
      placeholderText="Select Template"
      labelContainerStyle={{
        display: 'flex',
        alignItem: 'center',
        justifyContent: 'space-between',
        color: 'var(--text-subdued)',
      }}
      style={{ marginBottom: 0, fontSize: '16px' }}
      value={value}
      onChange={onChange}
      options={getOptions()}
      renderOption={renderOption}
      dropDownContainerStyle={{
        padding: 0,
        '& .MuiMenu-list': {
          padding: 0,
        },
      }}
    />
  );
}
